import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { BillingAddonDto, billingAddonFromDto } from '@nx-frontend/shared/types';

interface GetSubscriptionAddonParams {
  host: string;
  userId: number;
  subscriptionId: string;
  addonCode: string;
  /**
   * Secret for accessing internal services, not a super secret
   */
  secret: string;
}

export async function getSubscriptionAddon(params: GetSubscriptionAddonParams) {
  const { host, userId, subscriptionId, addonCode, secret } = params;
  const response = await axiosClient.get<BillingAddonDto>(
    `${assertServiceHost(host)}/v1/subscriptions/${subscriptionId}/addons/${addonCode}`,
    { userId, secret }
  );
  return billingAddonFromDto(response.data);
}
